<template>
  <v-container fluid>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 md12>
          <v-card class="fix_card" elevation="1">
            <v-card-text>
              <v-container grid-list-md text-xs-center>
                <div class="d-flex justify-center">
                  <img v-bind:src="computeImage" height="200" alt="Support Icon" />
                </div>
                <div class="d-flex justify-center">
                  <h4>We are here to help!</h4>
                </div>
              </v-container>
            </v-card-text>

            <v-spacer></v-spacer>

            <div class="d-flex justify-center">
              <div style="padding: 2%!important;">
                <v-btn @click="contact('email')" color="success">
                  Email
                </v-btn>
              </div>

              <div style="padding: 2%!important;">&nbsp;</div>

              <div style="padding: 2%!important;">
                <v-btn @click="contact('phone')" color="primary">
                  Call
                </v-btn>
              </div>

              <div style="padding: 2%!important;">&nbsp;</div>

              <div style="padding: 2%!important;">
                <v-btn @click="contact('learn')" color="purple" style="color:white">
                  Learn
                </v-btn>
              </div>
            </div>

            <div style="padding-top: 2%;"></div>

            <v-spacer></v-spacer>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-card class="main_card" elevation="1">
            <v-card-title>
              <span class="headline" style="letter-spacing: 0.5px">Diagnostics</span>
              <v-spacer></v-spacer>
              <v-btn @click="diagnostic('all')" class="btn" color="primary">Run Test</v-btn>
            </v-card-title>

            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-stepper
                    v-model="step"
                    vertical
                    style="margin-bottom: 10px; -webkit-box-shadow: none; box-shadow:none "
                  >
                    <v-stepper-step
                      :color="success ? 'success' : 'error'"
                      :complete="step > 1"
                      step="1"
                    >
                      Location Permission
                      <small v-if="step > 1">{{ locationPermissionMessage }}</small>
                    </v-stepper-step>

                    <v-stepper-content step="1">
                      {{ message }}
                    </v-stepper-content>

                    <v-stepper-step
                      :color="success ? 'success' : 'error'"
                      :complete="step > 2"
                      step="2"
                      >Location
                      <small v-if="step > 2">{{ locationMessage }}</small>
                    </v-stepper-step>

                    <v-stepper-content step="2">
                      {{ message }}
                    </v-stepper-content>

                    <v-stepper-step
                      :color="success ? 'success' : 'error'"
                      :complete="step > 3"
                      step="3"
                      >Camera Permission
                      <small v-if="step > 3">{{ cameraPermissionMessage }}</small></v-stepper-step
                    >

                    <v-stepper-content step="3">{{ message }}</v-stepper-content>

                    <v-stepper-step
                      :color="success ? 'success' : 'error'"
                      :complete="step > 4"
                      step="4"
                      >Camera <small v-if="step > 4">{{ cameraMessage }}</small></v-stepper-step
                    >
                    <v-stepper-content step="4">{{ message }}</v-stepper-content>

                    <v-stepper-step :complete="step > 5" color="success" step="5"
                      >Result</v-stepper-step
                    >
                    <v-stepper-content step="5">
                      <!-- Results -->
                      <h3 style="color: #212121">All the settings are working fine.</h3>
                    </v-stepper-content>
                  </v-stepper>

                  <div v-if="step == 5">
                    <v-divider></v-divider>

                    <v-card elevation="0" style="report_card">
                      <v-card-text>
                        <v-flex xs12 sm16>
                          <v-layout row wrap>
                            <v-flex xs8 sm8>
                              <h4>Diagnostic Report</h4>
                              <h6>
                                Your report has been generated successfully. Kindly send it us via
                                email
                              </h6>
                            </v-flex>
                            <v-flex xs4 sm4 style="text-align: right">
                              <v-btn @click="sendReport" color="primary">Send</v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-spacer></v-spacer>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-card elevation="1" class="fix_card">
            <v-card-title>
              <span class="headline" style="letter-spacing: 0.5px">Required Permissions </span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6" md="6">
                  <h4 style="margin-top: 12px;">Location</h4>
                </v-col>
                <v-col cols="6" md="6" justify="right" align="right">
                  <v-btn @click="diagnostic('permission.location.request')" color="primary"
                    >Request</v-btn
                  >
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" md="6">
                  <h4 style="margin-top: 12px;">Camera</h4>
                </v-col>
                <v-col cols="6" md="6" justify="right" align="right">
                  <v-btn @click="diagnostic('permission.camera.request')" color="primary"
                    >Request</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 style="text-align:center">
          <span text-xs-center style="text-align:center; ">
            <a @click="$router.push({ name: 'Privacy Policy' })" style="color:purple">Privacy</a> |
            <a @click="$router.push({ name: 'Terms of Service' })" style="color:purple">Terms</a>
          </span>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Report dialog -->
    <!-- <v-dialog v-model="reportDialog" persistent max-width="350" >
        <v-card style="border-radius: 2px" elevation="2">
          <v-card-title style="background-color: #0277BD">
            <h4 style="font-weight: 500; color: #FAFAFA">Report</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div v-for="(report, i) in reports" :key="i" style="padding: 10px">
              <h3 style="color: #424242; font-size: 16px; font-weight: 500">{{report}}</h3>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-action>
            <div style="text-align: right; padding: 5px">
              <v-btn flat color="primary" small @click="reportDialog = false">Close</v-btn>
              <v-btn color="primary" @click="sendReport">Send</v-btn>
            </div>
          </v-card-action>
        </v-card>
      </v-dialog> -->
  </v-container>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters, mapState } from "vuex";
import { EventBus } from "@/utilities/event-bus.js";

import canSee from "@/utilities/canSee";
import test from "@/utilities/tests";
import { userInfo } from "os";

export default {
  components: {
    SheetFooter: {
      functional: true,

      render(h, { children }) {
        return h(
          "v-sheet",
          {
            staticClass: "mt-auto align-center justify-center d-flex",
            props: {
              color: "rgba(0, 0, 0, .36)",
              dark: true,
              height: 50
            }
          },
          children
        );
      }
    }
  },
  data() {
    return {
      // reportDialog: false,
      computeImage: require("@/assets/nomembers.png"),
      // results: "",
      // reports: [],
      // logReport: false,
      step: 1,
      success: true,
      message: "",
      locationPermissionMessage: "",
      locationMessage: "",
      cameraPermissionMessage: "",
      cameraMessage: ""
    };
  },
  computed: {},
  created() {
    EventBus.$on("diag", data => {
      switch (data.event) {
        case "locationPermission":
          this.message = data.msg;
          if (data.data !== null) {
            this.success = data.success;
            this.step = 2;
            this.locationPermissionMessage = data.msg;
          } else {
            this.success = data.success;
          }

          break;

        case "location":
          this.message = data.msg;
          if (data.data !== null) {
            this.success = data.success;
            this.step = 3;
            this.locationMessage = data.msg;
          } else {
            this.success = data.success;
          }
          break;

        case "cameraPermission":
          this.message = data.msg;
          if (data.data !== null) {
            this.success = data.success;
            this.step = 4;
            this.cameraPermissionMessage = data.msg;
          } else {
            this.success = data.success;
          }
          break;

        case "camera":
          if (data.success) {
            this.success = data.success;
            this.message = data.msg;
            if (data.data !== null) {
              this.success = data.success;
              this.step = 5;
              this.cameraMessage = data.msg;
            } else {
              this.success = data.success;
            }
          }
          break;
      }
    });
  },
  methods: {
    contact(how) {
      if (how == "email") {
        window.open("mailto:support@regular.li?Subject=Email Support", "_system");
      } else if (how == "phone") {
        window.open("tel:+919674856639", "_system");
      } else {
        window.open("https://regular.li", "_system");
      }
    },
    // async test(which) {
    //   try {
    //     var res = await test(which, this)

    //     switch (which) {

    //       case "location":
    //         this.logReport = false;
    //         var html = [];
    //         for (var x in res) {
    //           let response = res[x];
    //           for (var d in response) {
    //             html.push(
    //               `${d} : ${typeof response[d] == "null" ? false : response[d]}`
    //             );
    //           }
    //           e;
    //         }
    //         // this.results = "Successful "+ JSON.stringify(res)
    //         this.location = true;
    //         this.results = html;
    //         break;

    //       case "camera":
    //         this.logReport = false;
    //         this.results = "<img src='" + res + "'>";
    //         break;

    //       case "permission.location":
    //         this.logReport = false;
    //         this.results = "Location permission is granted";
    //         break;

    //       case "permission.camera":
    //         this.logReport = false;
    //         this.results = "Camera is granted";
    //         break;

    //       case "report":

    //         this.logReport = true
    //         this.reportDialog = true

    //         var html = [];
    //         for (var x in res) {
    //           html.push(`${x} : ${res[x]}`);
    //         }
    //         // html += `<v-btn class='white--text v-btn v-btn--large theme--light pink' style='cursor: pointer' @click='sendReport(res)'>SEND</v-btn>`
    //         this.reports = html;
    //         break;
    //     }
    //   } catch (e) {
    //     this.results = "Failed \n" + JSON.stringify(e);
    //   }
    // },

    async diagnostic(which) {
      try {
        var log = await test(which, this);

        switch (which) {
          case "all":
            // this.logReport = false
            // this.reportDialog = false
            break;

          case "report":
            this.logReport = true;
            this.reportDialog = true;

            var html = [];
            for (var x in res) {
              html.push(`${x} : ${res[x]}`);
            }
            // html += `<v-btn class='white--text v-btn v-btn--large theme--light pink' style='cursor: pointer' @click='sendReport(res)'>SEND</v-btn>`
            this.reports = html;
            break;
          case "permission.location.request":
            if (log)
              navigator.notification.alert(
                "Location permission granted", // message
                () => {}, // callback
                "Regular.li", // title
                "Okay" // buttonName
              );
            else
              navigator.notification.alert(
                "Location permission issue", // message
                () => {}, // callback
                "Regular.li", // title
                "Okay" // buttonName
              );
            break;
          case "permission.camera.request":
            if (log)
              navigator.notification.alert(
                "Camera permission granted", // message
                () => {}, // callback
                "Regular.li", // title
                "Okay" // buttonName
              );
            else
              navigator.notification.alert(
                "Camera permission issue", // message
                () => {}, // callback
                "Regular.li", // title
                "Okay" // buttonName
              );

            break;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async sendReport() {
      var log = await test("report", this);

      var logData = "";
      _.each(log, l => {
        logData += l;
      });

      var dataToSend = {};
      dataToSend.log = logData;
      dataToSend.settings = this.$store.state.userDetails;

      var userEmail = this.$store.state.userDetails.email;
      document.addEventListener(
        "deviceready",
        () => {
          cordova.plugins.email.isAvailable(function(isAvailable) {
            if (isAvailable) {
              cordova.plugins.email.open({
                to: ["support@regular.li"],
                subject: "Debug Dump from " + userEmail,
                body: JSON.stringify(dataToSend),
                isHtml: false
              });
            } else {
              window.open(
                "mailto:support@regular.li?subject=DebugDump from " +
                  userEmail +
                  "&body=" +
                  encodeURIComponent(JSON.stringify(logData)),
                "_system"
              );
            }
          });
        },
        false
      );
    }
  }
};
</script>

<style scoped>
.main_card {
  border-radius: 2px;
  padding: 2px;
}

.fix_card {
  border-radius: 2px;
  padding: 2px;
}

.report_card {
  border-radius: 2px;
  padding: 2px;
  /* box-shadow: none; */
  margin-top: 10px;
}

h6 {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
}
h4 {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

h3 {
  font-size: 15px;
}
h1,
h2 {
  font-weight: normal;
}
.gps-btn {
  /* margin-left: 327px;
  z-index: 1;
  top: -35px; */
  margin-left: -190px;
  background: transparent !important;
  box-shadow: none !important;
}
@media only screen and (max-width: 600px) {
  .gps-btn {
    margin-left: -120px;
  }
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.company-save-btn {
  color: #ffffff;
  letter-spacing: 1px;
  margin-bottom: 20px;
  font-size: 16px;
}
a {
  color: #ffffff;
  text-decoration-style: none;
  text-decoration-line: none;
}
</style>
